<script setup lang="ts">
import type { NovaHeaderMobileProps } from './NovaHeaderMobile.types'

const props = withDefaults(defineProps<NovaHeaderMobileProps>(), {
  title: '',
  showBackAction: false,
  backAction: undefined,
  chatbotLabel: false,
})
/* const handleOnBack = () => {
  useNavigations({ type: 'back' })
} */
const handleOnBack = () => {
  if (props.backAction && typeof props.backAction === 'function') {
    // 부모로부터 받은 커스텀 함수 실행
    props.backAction()
  } else {
    // 기본 뒤로가기 동작
    useNavigations({ type: 'back' })
  }
}
</script>

<template>
  <div class="mobile-header">
    <NovaButtonIcon
      v-if="showBackAction"
      :icon="{ type: 'outline', name: 'arrow-left' }"
      class="navigation-button"
      @click="handleOnBack"
    />
    <h4 class="title">{{ title }}</h4>
    <span v-if="chatbotLabel" class="chatbot-label">BETA</span>
  </div>
</template>

<style lang="scss" scoped>
.mobile-header {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  height: 63px;
  padding: 0 22px;
  background-color: $color-white;
  border-bottom: 1px solid $color-neutral-light-2;

  @include mobile {
    height: 61px;
  }

  .navigation-button {
    width: 36px;
    height: 36px;
    font-size: 36px;

    :deep(.icon) {
      font-size: 27px !important;
    }
  }

  .title {
    @include text-style($text-heading2-bold);
  }

  .chatbot-label {
    display: inline-block;
    padding: 0 8px;
    @include text-style($text-body-14-regular);
    color: $color-blue-900;
    border: 1px solid $color-blue-900;
    border-radius: 12px;
    margin-left: -22px;
  }
}
</style>
